/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable camelcase */
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Icon, createPortalComponent } from '@ezugi/primitives';
import bgImg from '@ezugi/static/error_bg.png';
import maintenanceIcon from '@ezugi/static/icons/maintenance.svg';
import warningIcon from '@ezugi/static/icons/warning.svg';

import { sendAnalytics } from '../../../../analytics/sendAnalytics';
import { useIntl } from '../../hooks/useIntl';
import { menuActions } from '../../store/actions';
import { canGoHomeSelector } from '../../store/selectors';
import { errorSelector, showNavigationSelector } from '../../store/selectors/error';
import {
  actionClassName,
  titleClassName,
  descriptionClassName,
  linkClassName,
  containerClassName,
  messageClassName,
  iconClassName,
} from './style.css';

const { home } = menuActions;

const Portal = createPortalComponent('game-error-container');

const GameError = () => {
  const dispatch = useDispatch();

  const error = useSelector(errorSelector);
  const canGoHome = useSelector(canGoHomeSelector);

  const showNavigation = useSelector(showNavigationSelector);

  const intlSpec = useMemo(
    () => ({
      keys: {
        title: error.title || `errors.title_${error.code}`,
        description: error.description || `errors.desc_${error.code}`,
        homeLabel: error.actionLabel || 'general.home',
        goBack: 'general.go_back',
      },
      variables: error.variables,
    }),
    [
      error.title,
      error.code,
      error.description,
      error.actionLabel,
      error.variables,
    ]
  );

  const { title, description, homeLabel, goBack } = useIntl(intlSpec);

  return (
    <Portal>
      <div className={containerClassName} style={{ backgroundImage: `url(${bgImg})` }}>
        <div className={messageClassName}>
          <Icon
            svg={error.code === 111 ? maintenanceIcon : warningIcon}
            size={90}
            className={iconClassName}
            disabled={true}
          />
          <h1 className={titleClassName}>
            {title}
          </h1>
          <p className={descriptionClassName} dangerouslySetInnerHTML={{ __html: description }} />
        </div>
        { showNavigation && (canGoHome ? (
          <button
            className={actionClassName}
            type="button"
            onClick={() => {
              sendAnalytics({ error_id: error.code, click_type: 'home' });
              dispatch(home.request());
            }}
          >
            {homeLabel}
          </button>
        ) : (
          <a
            className={linkClassName}
            onClick={() => {
              sendAnalytics({ error_id: error.code, click_type: 'back' });
              history.back();
            }}
          >
            {goBack}
          </a>
        ))}
      </div>
    </Portal>
  );
};

export default GameError;
